<ol>
  @for (entry of entries; track entry.id; let i = $index) {
    <li><button type="button" class="ranking" [disabled]="disabled || !entry.id" (click)="entry.id && pick.emit(entry.id)">
      <span class="rank">{{ i + 1 }}</span>
      <span class="rank-body">
        <span class="rank-name">{{ entry.name }}</span>
        <span class="rank-track"><span [style.width.%]="percent(entry.count, entries[0].count)"></span></span>
      </span>
      <span class="rank-value"><strong>{{ entry.count | number }}</strong><small>{{ percent(entry.count, total) | number:'1.0-0' }} %</small></span>
    </button></li>
  } @empty { <li class="empty"><i [class]="emptyIcon" aria-hidden="true"></i><span i18n="@@activityNoOpens">Keine Kachel-Aufrufe im gewählten Zeitraum.</span></li> }
</ol>
